import {Component} from 'react';
import h from 'react-hyperscript';
import './FourCs.scss';
import Bucket from './Bucket';

class FourCs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collaboration_open: false,
      communication_open: false,
      creativity_open: false,
      critical_thinking_open: false,
    };
  }

  render() {
    return (
      h('div', {
        id: 'customizable-four-cs',
        className: 'flex flex--align-start flex--wrap',
      }, this.props.buckets.map((bucket, i) => {
        const _bucket = bucket.toLowerCase().replace(' ', '_');
        const activeProductsInBucket = this.props.activeBuckets[_bucket];
        const id = `${_bucket}_remaining`;
        const remainingProductsInBucket = this.props.activeBuckets[id];

        return (
          h(Bucket, {
            key: `${bucket}__key`,
            totalProducts: this.props.products,
            bucketTitle: bucket,
            bucketId: _bucket,
            activeProducts: activeProductsInBucket,
            remainingProducts: remainingProductsInBucket,
            handleRemoveFromBucket: this.props.handleRemoveFromBucket,
            handleAddToBucket: this.props.handleAddToBucket,
          }, null)
        );
      })
      )
    );
  }
}

export default FourCs;
